import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
    AvailabilityCheckMetaType,
    ChargesType,
    CmsPageContentIdentifier,
    CmsPageContentType,
    CmsTariffContentType,
    EcommerceProductValue,
    FixedLineAccessTechnologyType,
    NextPriceChargesType, ReduxStateType,
    TariffCatalogType,
    TariffOfferType, TariffPositionsType,
} from '@/types/av-check';
import {connect} from 'react-redux';
import {Price} from '@/components/compendium';
import {
    currencyParts, formatDate, formatDateWithoutDate, formatDateWithTwoDigitsInYear,
    formateDateWithMonthNameAndYear,
    formatPrice,
    getAvailableTariffs,
    getChargesNatureForTechnologySelectionModal, getCMSSnippetForDisplayPriceItemId,
    getHighlightedTechnology,
    getTariffOfferComparator,
    interpolate, isExpansionPeriodEndInFuture,
} from '@/utils';
import StaticContentModal from '@/components/modal/static-content-modal';
import {
    buildDataForChooseFtthClick,
    buildDataForProductClickSelectTechnology,
    buildDataForQuestionareModuleDisplay,
    pushToTefDataLayer
} from '@/services/tracking';

interface TechnologySelectionModalProps {
  cmsContent: CmsPageContentType,
  tariffOfferGroup: TariffCatalogType,
  ecommerceProductValues: EcommerceProductValue[]
  meta: AvailabilityCheckMetaType,
  taroPricingPromotionEnabled: boolean,
  setFtthModelRedirectionState: Dispatch<SetStateAction<boolean>>,
  setFtthSelectedTariffState:Dispatch<TariffOfferType>
  setFtthmodalTariffPositionsState:Dispatch<TariffPositionsType>
  isRedirectedFromFtthSelection:boolean,
  ftthExpansionStatus:string,
  isDtagToggleShopEnabled: boolean,
  isDtagToggleCciEnabled:boolean,
  isDtagGeneralToggleEnabled: boolean,
  isDtagGuiEnhancementsToggleEnabledForShop: boolean,
  isDtagGuiEnhancementsToggleEnabledForCci: boolean,
  isDisplayPricingEnabled: boolean,
  isTariffShortNameToggleEnabled: boolean,
  isCciTheme: boolean
}
const css = `
         .modal-dialog:not(.modal-video).modal-has-footer.modal-scrollable-bottom .modal-content.techSelection:after{
          opacity:0 !important; 
       }
`;
const TechnologySelectionModal: React.FC<TechnologySelectionModalProps> = (
    {
        cmsContent,
        tariffOfferGroup,
        ecommerceProductValues,
        meta,
        taroPricingPromotionEnabled,
        isRedirectedFromFtthSelection,
        ftthExpansionStatus,
        setFtthModelRedirectionState,
        setFtthSelectedTariffState,
        setFtthmodalTariffPositionsState,
        isDtagToggleShopEnabled,
        isDtagToggleCciEnabled,
        isDtagGeneralToggleEnabled,
        isDtagGuiEnhancementsToggleEnabledForShop,
        isDtagGuiEnhancementsToggleEnabledForCci,
        isDisplayPricingEnabled,
        isTariffShortNameToggleEnabled,
        isCciTheme
    }: TechnologySelectionModalProps,
) => {
  const tariffCatalog = tariffOfferGroup && getAvailableTariffs(tariffOfferGroup).sort(getTariffOfferComparator());
  const getModalTariffPositions = () : TariffPositionsType => {
    let tariffIndex=0;
    const modalTariffPositions : TariffPositionsType= {};
    tariffCatalog.forEach((tariff:any)=>{
      modalTariffPositions[tariff.offerName]= tariffIndex+=1;
    });
    return modalTariffPositions;
  }
  let mainOffer: TariffOfferType;
   mainOffer = getHighlightedTechnology(tariffOfferGroup) || tariffCatalog[0];

  const name: CmsTariffContentType = (mainOffer && (isTariffShortNameToggleEnabled ? mainOffer.cmsTariffDescription.shortName : mainOffer.cmsTariffDescription.name)) || '';
  const downloadBandwidthText: CmsTariffContentType = (mainOffer && mainOffer.cmsTariffDescription.downloadBandwidthText) || '';
  const mainOfferTitle = mainOffer
    ? (`${name.rendered} ${downloadBandwidthText.rendered}`)
    : '';
  const TECHNOLOGY_SELECTION_MODAL_ID = 'modal-technologieauswahl';
  const [selectedTariff, setSelectedTariff] = useState(mainOffer);
  const [selectedTariffInfoModalContent, setSelectedTariffInfoModalContent] = useState(['', '']);
  const chargesNature =  getChargesNatureForTechnologySelectionModal(tariffCatalog);
    const isDtagToggleEnabled: boolean|undefined = isDtagToggleShopEnabled || isDtagToggleCciEnabled;
    const isDtagGuiEnhancementsToggleEnabled: boolean | undefined = isDtagGuiEnhancementsToggleEnabledForShop || isDtagGuiEnhancementsToggleEnabledForCci;
    useEffect(() => {
      if (!isRedirectedFromFtthSelection) {
          setSelectedTariff(mainOffer);
      }
  }, [tariffOfferGroup]);

  const closeButton = () => (
    <div className="modal-header">
      <button className="close" type="button" data-dismiss="modal" data-tracking-action="close">
        <span>&#xD7;</span>
      </button>
    </div>
  );

  const tariffAlert = () => (
      <tef-alert type="success">
          <div slot="headline">
              <span>Gute Wahl: </span><span dangerouslySetInnerHTML={{__html: mainOfferTitle}}/>
          </div>

          <div slot="content">
              <p>{cmsContent[CmsPageContentIdentifier.AvailableTechnologiesSubheader]}</p>
          </div>
      </tef-alert>
  );

  function getTeaserLabelForAccessTechnology(accessTechnology: FixedLineAccessTechnologyType) {
    switch (accessTechnology) {
        case FixedLineAccessTechnologyType.FMS:
            return <span dangerouslySetInnerHTML={{__html: cmsContent[CmsPageContentIdentifier.FmsTechnologyLabel]}}/>
        case FixedLineAccessTechnologyType.COAX:
            return <span dangerouslySetInnerHTML={{__html: cmsContent[CmsPageContentIdentifier.CoaxTechnologyLabel]}}/>
        case FixedLineAccessTechnologyType.DSL:
            return <span dangerouslySetInnerHTML={{__html: cmsContent[CmsPageContentIdentifier.DslTechnologyLabel]}}/>
        case FixedLineAccessTechnologyType.FTTH:
            return <span dangerouslySetInnerHTML={{__html: cmsContent[CmsPageContentIdentifier.FtthTechnologyLabel]}}/>
      default:
        return '';
    }
  }

    function getTeaserBandwidthForAccessTechnology(accessTechnology: FixedLineAccessTechnologyType, tariffUploadBandWidth:string) {
        switch (accessTechnology) {
            case FixedLineAccessTechnologyType.FMS:
                return interpolate(cmsContent[CmsPageContentIdentifier.FmsTechnologyInfoLabel], { maxUploadBandWidth: tariffUploadBandWidth });
            case FixedLineAccessTechnologyType.COAX:
                return interpolate(cmsContent[CmsPageContentIdentifier.KabelTechnologyInfoLabel], { maxUploadBandWidth: tariffUploadBandWidth })
            case FixedLineAccessTechnologyType.DSL:
                return interpolate(cmsContent[CmsPageContentIdentifier.DslTechnologyInfoLabel], { maxUploadBandWidth: tariffUploadBandWidth })
            case FixedLineAccessTechnologyType.FTTH:
                return interpolate(cmsContent[CmsPageContentIdentifier.FtthTechnologyInfoLabel], { maxUploadBandWidth: tariffUploadBandWidth })
            default:
                return '';
        }
    }

  function getAccessTechnologyInfoDescriptionForAccessTechnology(accessTechnology: FixedLineAccessTechnologyType) {
    switch (accessTechnology) {
      case FixedLineAccessTechnologyType.FMS:
        return cmsContent[CmsPageContentIdentifier.FmsTechnologyInfoDescription];
      case FixedLineAccessTechnologyType.COAX:
        return cmsContent[CmsPageContentIdentifier.CoaxTechnologyInfoDescription];
      case FixedLineAccessTechnologyType.DSL:
        return cmsContent[CmsPageContentIdentifier.DslTechnologyInfoDescription];
        case FixedLineAccessTechnologyType.FTTH:
            return cmsContent[CmsPageContentIdentifier.FtthTechnologyInfoDescription];
      default:
        return '';
    }
  }

  function getAccessTechnologyInfoHeaderForAccessTechnology(accessTechnology: FixedLineAccessTechnologyType) {
    switch (accessTechnology) {
      case FixedLineAccessTechnologyType.FMS:
        return cmsContent[CmsPageContentIdentifier.FmsTechnologyInfoHeader];
      case FixedLineAccessTechnologyType.COAX:
        return cmsContent[CmsPageContentIdentifier.CoaxTechnologyInfoHeader];
      case FixedLineAccessTechnologyType.DSL:
        return cmsContent[CmsPageContentIdentifier.DslTechnologyInfoHeader];
        case FixedLineAccessTechnologyType.FTTH:
            return cmsContent[CmsPageContentIdentifier.FtthTechnologyInfoHeader];
      default:
        return '';
    }
  }

  const setAccessTechnologyInfoModal = (accessTechnology: FixedLineAccessTechnologyType) => {
    const accessTechnologyInfoDescriptionForAccessTechnology = getAccessTechnologyInfoDescriptionForAccessTechnology(accessTechnology);
    const accessTechnologyInfoHeaderForAccessTechnology = getAccessTechnologyInfoHeaderForAccessTechnology(accessTechnology);
    setSelectedTariffInfoModalContent([accessTechnologyInfoHeaderForAccessTechnology, accessTechnologyInfoDescriptionForAccessTechnology]);
  };

  const price = (charges: ChargesType, accessType: string) => {
      const techPricingAvailableGroup = chargesNature == "TECHNOLOGY_PRICING";
      const isDtagFtthTarif = accessType === "DTAG-FTTH-ETH";
      const infoIcon = (glasfaserCostName:string) => (
          <a
              className="modal-link info"
              style={infoIconColor}
              data-toggle="modal"
              href={glasfaserCostName}
          />
      );
      let euros, cents, cond_text, technologyPricingLabel, nextCharges;
      let displayPriceList: string[] = [];

      function getModifiedPricePointId(itemId: string) {
          if (isDtagFtthTarif && (itemId.includes("installation-fee") || itemId.includes("development-fee"))) {
              return itemId + "-info";
          }
          return itemId;
      }

      if(isDisplayPricingEnabled && charges.tariffDisplayPrice) {
          const displayPrice = charges.tariffDisplayPrice;
          [euros, cents] = currencyParts(displayPrice.monthlyPrice.value);
          cond_text = <span dangerouslySetInnerHTML={{ __html: cmsContent[getCMSSnippetForDisplayPriceItemId(
                  displayPrice.monthlyPrice.itemId)] }} />;
          nextCharges = charges.tariffDisplayPrice.nextPriceChargeDataList
              .map(({ recurringCosts, startingMonth }) =>  interpolate(cmsContent[CmsPageContentIdentifier.monthlyPriceNext],
                  {months: startingMonth, nextPrice:formatPrice(recurringCosts)} ));
          displayPriceList = displayPrice.priceCategoryWithRankDataList.map(priceCategoryWithRankData => {
              const modifiedPricePointId = getModifiedPricePointId(priceCategoryWithRankData.itemId);
              const text  = cmsContent[getCMSSnippetForDisplayPriceItemId(modifiedPricePointId)];
              return text != undefined ? interpolate( text,
                  {value: formatPrice(Math.abs(priceCategoryWithRankData.value)), maxValue: formatPrice(Math.abs(priceCategoryWithRankData.maxValue))}) : '';
          });
      }else {
          [euros, cents] = techPricingAvailableGroup ? currencyParts(charges.recurringCosts) : currencyParts(charges.activationFee);
          cond_text = techPricingAvailableGroup ? "monatlich" :( isDtagFtthTarif ?
              (<> <span>einmaliger Anschlusspreis</span> {infoIcon("#glasfaserActivationCostInfoModal")} </>)
              : "einmaliger Anschlusspreis");
          const nextPriceChargesEqualRecurringCharges = (
              nextPriceCharges: NextPriceChargesType, recurringCharges: number,
          ) => nextPriceCharges.recurringCosts === recurringCharges;
          nextCharges = charges.nextPriceCharges
              .filter((nextPriceCharges) => !nextPriceChargesEqualRecurringCharges(
                  nextPriceCharges, charges.recurringCosts,
              ) && techPricingAvailableGroup)
              .map(({ recurringCosts, startingMonth }) => `ab ${startingMonth}. Monat ${formatPrice(recurringCosts)} mtl.`);
      }

    const infoIconColor = {color: "#0090d0"};
      const techPricingAvailable = (taroPricingPromotionEnabled: boolean) => {
          if(!isDisplayPricingEnabled && charges.recurringDetails.TECHNOLOGY_CHARGE){
              if(charges.recurringDetails.TECHNOLOGY_CHARGE < 0) {
                  technologyPricingLabel = taroPricingPromotionEnabled ? interpolate(cmsContent[CmsPageContentIdentifier.TechnologyPricingOneTimeMonthlyDiscount],
                      {price: formatPrice(Math.abs(charges.recurringDetails.TECHNOLOGY_CHARGE))}):
                      interpolate(cmsContent[CmsPageContentIdentifier.TechnologyPricingDiscountLabel],
                          {discountValue: formatPrice(Math.abs(charges.recurringDetails.TECHNOLOGY_CHARGE))});
              }
              if(charges.recurringDetails.TECHNOLOGY_CHARGE > 0) {
                  technologyPricingLabel = interpolate(cmsContent[CmsPageContentIdentifier.TechnologyPricingSurchargeLabel],
                      {surchargeValue: formatPrice(charges.recurringDetails.TECHNOLOGY_CHARGE)});
              }
              return true;
          }else{
              return false;
          }
      }


    return (
        <div className="pricing">
          <Price
              cond={cond_text}
              sum={euros}
              suffix={cents}
              condAfter={(

                   <>
                    {
                      techPricingAvailable(taroPricingPromotionEnabled) &&
                      (
                          <>
                            {technologyPricingLabel}
                            <br />
                          </>
                      )
                    }
                    {nextCharges.map((nc, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <React.Fragment key={index}>
                          {nc}
                          <br />
                        </React.Fragment>
                    ))}
                    {displayPriceList.map((displayText, index) => (
                        <React.Fragment key={index}>
                            <span dangerouslySetInnerHTML={{ __html: displayText}} />
                            <br />
                        </React.Fragment>
                     ))
                    }
                    {
                      (!isDisplayPricingEnabled && charges.activationFee > 0 && techPricingAvailableGroup) &&
                      (<> <p style={{fontWeight : 'normal', margin: '0 0 1px'}}>
                          {`+ ${formatPrice(charges.activationFee)} einmaliger Anschlusspreis `}
                          { isDtagFtthTarif && infoIcon("#glasfaserActivationCostInfoModal")}
                      </p>
                      </>)
                    }
                     {(!isDisplayPricingEnabled && taroPricingPromotionEnabled && charges.priceCategoryWithRanks)&& charges.priceCategoryWithRanks.filter(price => price.value >= 0).map((nc, index) => (
                        <>
                            {nc.category === 'DEVELOPMENT_COST_CHARGE' &&
                            ( <>
                                <p style={{fontWeight : 'normal', margin: '0 0 1px'}}>
                                    { interpolate(cmsContent[CmsPageContentIdentifier.TechnologyPricingDevelopmentCharge],
                                        {price: formatPrice(nc.value), from: isDtagFtthTarif && !isRedirectedFromFtthSelection ? "ab" : ""})}
                                    { isDtagFtthTarif && infoIcon("#glasfaserDevelopmentCostInfoModal")}
                                </p>
                            </>)}

                            {nc.category === 'INFRASTRUCTURE_FEE_CHARGE' && ( <>{interpolate(cmsContent[CmsPageContentIdentifier.TechnologyPricingInfrastructureCharge],
                              {price: formatPrice(nc.value)})}<br /></>) }
                        </>
                     ))}

                     {(!isDisplayPricingEnabled && taroPricingPromotionEnabled && charges.priceCategoryWithRanks) && charges.priceCategoryWithRanks.filter(price => price.value <= 0).map((nc, index) => (
                         <>
                           {nc.category === 'DEVELOPMENT_COST_DISCOUNT' && ( <>{interpolate(cmsContent[CmsPageContentIdentifier.TechnologyPricingDevelopmentDisount],
                               {price: formatPrice(Math.abs(nc.value))})}<br /></>) }
                           {nc.category === 'ACTIVATION_FEE_DISCOUNT' && ( <>{interpolate(cmsContent[CmsPageContentIdentifier.TechnologyPricingConnectionDiscount],
                               {price: formatPrice(Math.abs(nc.value))})}<br /></>) }
                         </>
                     ))}
                  </>
              )}
          />
        </div>
    );
  };

    const technologySelectionTeaser = (tariffOffer: TariffOfferType, index: number) => {
    const selectedStyle = tariffOffer.tariffVariationCode === selectedTariff.tariffVariationCode &&
    tariffOffer.offerName === selectedTariff.offerName ? 'selected' : '';
    const isCurTariffDtagFtth = tariffOffer.accessType == 'DTAG-FTTH-ETH';
    const isCurTariffFtth = tariffOffer.accessType == 'DTAG-FTTH-ETH' || 'UGG-FTTH-ETH';
    const earliestAvailabilityDateModal: string|undefined = tariffOffer.earliestActivationDate ? formatDateWithTwoDigitsInYear(tariffOffer.earliestActivationDate) : undefined;
    const earliestAvailabilityDateModalCmsContent: string = earliestAvailabilityDateModal  && !isCurTariffDtagFtth ? interpolate(cmsContent[CmsPageContentIdentifier.FtthEarliestAvailabilityDateModal], {date: earliestAvailabilityDateModal}) : "";
      const isBeforePrepared : boolean|undefined = isCurTariffDtagFtth && tariffOffer.technologyAvailability ?
          !tariffOffer.technologyAvailability?.homeIdPossible   :undefined;

        let expansionStatusStartDate = isCurTariffFtth && tariffOffer.technologyAvailability &&
        tariffOffer.technologyAvailability.expansionPeriodStart ? isDtagGuiEnhancementsToggleEnabled && isCurTariffDtagFtth ?
            formatDate(tariffOffer.technologyAvailability?.expansionPeriodStart) :
            formatDateWithoutDate(tariffOffer.technologyAvailability?.expansionPeriodStart) : undefined ;
        let expansionStatusEndDate = isCurTariffFtth && tariffOffer.technologyAvailability &&
        tariffOffer.technologyAvailability.expansionPeriodEnd ?
            isDtagGuiEnhancementsToggleEnabled && isCurTariffDtagFtth ?
                formatDate(tariffOffer.technologyAvailability?.expansionPeriodEnd) :
                formatDateWithoutDate(tariffOffer.technologyAvailability?.expansionPeriodEnd) : undefined ;
        const isExpansionEndDateInFuture :boolean|undefined = isCurTariffFtth && tariffOffer.technologyAvailability && tariffOffer.technologyAvailability.expansionPeriodEnd ?
            isExpansionPeriodEndInFuture(tariffOffer.technologyAvailability?.expansionPeriodEnd) : undefined;
        let expansionPeriodEndLabel: string | undefined = expansionStatusStartDate && expansionStatusEndDate ? `${expansionStatusStartDate} und ${expansionStatusEndDate}`:undefined;
        return (
            <article className={`teaser teaser-with-price teaser-connection-type ${selectedStyle}`}>
        <div className="content">
          <div className="teaser-connection-input">
            <div className="radio">
              <input
                id={`radio-auto-id-${index}`}
                checked={tariffOffer.tariffVariationCode === selectedTariff.tariffVariationCode &&
                tariffOffer.offerName === selectedTariff.offerName}
                type="radio"
                name={`select-${tariffOffer.offerName}`}
              />
              <label htmlFor={`radio-auto-id-${index}`} onClick={() => setSelectedTariff(tariffOffer)}>
                {getTeaserLabelForAccessTechnology(tariffOffer.accessTechnology)}
                  {(tariffOffer.earliestActivationDate && !tariffOffer.technologyAvailability.homeIdPossible) &&
                    <span dangerouslySetInnerHTML={{ __html: earliestAvailabilityDateModalCmsContent}} />}
              </label>
            </div>
              {isDtagGeneralToggleEnabled &&
                  <span style={{ fontFamily: 'FrutigerLight,Verdana,Tahoma,sans-serif'}}
                        dangerouslySetInnerHTML={{ __html: getTeaserBandwidthForAccessTechnology(tariffOffer.accessTechnology,tariffOffer.tariffUploadBandWidth) }}/>}
          </div>
          <div>
          <div className="text" style={{paddingRight: '0px'}}>
              <p style={{fontWeight : 'normal'}}>
              {tariffOffer.cmsTariffDescription.accessTechnologyDescription.rendered}
              {!isDtagGeneralToggleEnabled &&
                  <a
                      className="modal-link info"
                      data-toggle="modal"
                      href="#technologySelectInfoModal"
                      onClick={() => setAccessTechnologyInfoModal(tariffOffer.accessTechnology)}
                  />
              }
            </p>
          </div>
          {price(tariffOffer.charges, tariffOffer.accessType)}
          <div dangerouslySetInnerHTML={{__html: cmsContent[CmsPageContentIdentifier.ComboBenefitInfo]}} style={{fontSize:"14px !important"}}/>
          {isDtagToggleEnabled && isBeforePrepared && (!isDisplayPricingEnabled && taroPricingPromotionEnabled && tariffOffer.charges.priceCategoryWithRanks) &&
              tariffOffer.charges.priceCategoryWithRanks.filter(price => price.value >= 0).map((nc, index) => (
                  <>
                      <style> {occlPromoBox} </style>
                          <div className="occlPromo">
                              {nc.category === 'DEVELOPMENT_COST_CHARGE' && (
                                  <tef-promo-box cloak color-scheme="bg-light-grey">
                                      <div slot="title">
                                          <div
                                              dangerouslySetInnerHTML={{
                                                  __html: interpolate(cmsContent[CmsPageContentIdentifier.DevelopmentPrinceInfoText], {
                                                      value: formatPrice(nc.value),
                                                      maxValue: formatPrice(nc.maxValue)
                                                  })
                                              }}
                                          />
                                      </div>
                                  </tef-promo-box>
                               )
                              }
                          </div>
                      </>
                  ))}
          {isDtagToggleEnabled && isBeforePrepared && isExpansionEndDateInFuture &&
              <tef-alert type="hint">
                  <div slot="content">
                      <strong>
                          <div dangerouslySetInnerHTML={{__html: `${cmsContent[CmsPageContentIdentifier.FtthAlertBoxText]} ${expansionPeriodEndLabel}`}}/>
                      </strong>
                      {(!isDisplayPricingEnabled && taroPricingPromotionEnabled && tariffOffer.charges.priceCategoryWithRanks) &&
                          tariffOffer.charges.priceCategoryWithRanks.filter(price => price.value >= 0).map((nc, index) => (
                              <>
                                  {nc.category === 'DEVELOPMENT_COST_CHARGE' &&
                                      (<>
                                          <div slot="title">
                                              <div
                                                  dangerouslySetInnerHTML={{
                                                      __html: interpolate(cmsContent[CmsPageContentIdentifier.OcclDevelopmentPrinceInfoText], {
                                                          value: formatPrice(nc.value),
                                                          maxValue: formatPrice(nc.maxValue)
                                                      })
                                                  }}
                                              />
                                          </div>
                                      </>)
                                  }
                              </>
                          ))}
                  </div>
              </tef-alert>
          }
        </div>
          { index === 0 && <div style={{position: 'absolute', top: '0px', right: '0px'}} dangerouslySetInnerHTML={{__html: meta.cciTheme ? cmsContent[CmsPageContentIdentifier.HighlightedTechnologyDisturberCCI] : cmsContent[CmsPageContentIdentifier.HighlightedTechnologyDisturber]}}/>}
        </div>
      </article>
    );
  };

  const serviceTeaser = () => (
        <>
            <style> {modelFooterStyle} </style>
    <div
      className="item-collection item-collection-wide item-collection-block item-collection-desktop"
    >
      <div className="items" style={{fontFamily: 'FrutigerLight,Verdana,Tahoma,sans-serif'}}>
        <article className="article article-wide">
          <div className="footer-row">
              <div className="left-column">
                  <p>
                      <tef-icon cloak icon="call" size="2" type="functional"></tef-icon>
                      <strong className="head-left">
                          {cmsContent[CmsPageContentIdentifier.ModalFooterHeadline]}
                                    </strong>
                                </p>
                                <article className="teaser teaser-quick-content teaser-quick-content-small">
                                    <div className="fcontent">
                                        <div className="footerhead">
                                        {cmsContent[CmsPageContentIdentifier.ModalFooterDescription]}
                                      </div>
                                  </div>
                              </article>
                          </div>
                          <div className="right-column">
                              <p style={{fontSize:"18px"}}>
                                  <strong>
                                      {cmsContent[CmsPageContentIdentifier.FtthAvailabilityModalFooterInfo]}
                                  </strong>
                              </p>
                              <article className="teaser teaser-quick-content teaser-quick-content-small">
                                  <div className="fcontent">
                                      <div className="footerhead">
                                          {cmsContent[CmsPageContentIdentifier.HomeAvailabilityModalContactDiscription]}
                                      </div>
                                      <div className="ftext" style={{fontSize:"18px"}}>
                                          <strong>
                                              {cmsContent[CmsPageContentIdentifier.HomeAvailabilityModalContactInfo]}
                                          </strong>
                                      </div>
                                  </div>
                              </article>
                          </div>
                      </div>
                  </article>
              </div>
          </div>
      </>
  );

  const technologySelectionTeasersForTariffGroup = () => (tariffCatalog.map((tariffOffer, index) => {
    if (tariffOffer) {
      return technologySelectionTeaser(tariffOffer, index);
    }
    return undefined;
  }));

  const availableTechnologiesSelection = () => (
    <div className="item-collection item-collection-wide" style={{paddingTop:"10px"}}>
      <div className="items">
        {tariffOfferGroup && technologySelectionTeasersForTariffGroup()}
      </div>
    </div>
  );

  const closeTechnologySelectionModel = () => {
    ($(`#${TECHNOLOGY_SELECTION_MODAL_ID}`) as any).modal('hide');
  };
  const isSelectedTariffDtagFtth = selectedTariff && selectedTariff.accessType == 'DTAG-FTTH-ETH';
  const isFtthExpansionStatus = ftthExpansionStatus !== 'ready' && ftthExpansionStatus !== 'prepared';
  const continueButton = () => (

        <a
            className="btn js-connection-type"
            data-toggle={ isSelectedTariffDtagFtth && !isRedirectedFromFtthSelection ? 'modal' : null}
            data-target={ isSelectedTariffDtagFtth && !isRedirectedFromFtthSelection ? '#modal-technologieauswahlftth' : null}
            href={selectedTariff ? isSelectedTariffDtagFtth && !isRedirectedFromFtthSelection ? '#modal-technologieauswahlftth' : selectedTariff.url : '#' }
            onClick={() => {
              closeTechnologySelectionModel();
              if ( isRedirectedFromFtthSelection || !isSelectedTariffDtagFtth) {
                  pushToTefDataLayer(window, buildDataForProductClickSelectTechnology(selectedTariff,
                  mainOffer.offerName === selectedTariff.offerName, ecommerceProductValues,
                  getModalTariffPositions()));
              } else if(isSelectedTariffDtagFtth && isFtthExpansionStatus) {
                  if(isCciTheme) {
                      document.location.href = selectedTariff.url;
                  } else {
                      Promise.resolve(pushToTefDataLayer(window, buildDataForChooseFtthClick(selectedTariff, selectedTariff.accessTechnology, mainOffer.offerName === selectedTariff.offerName, getModalTariffPositions())))
                          .then(() => {
                              setTimeout(() => {
                                  document.location.href = selectedTariff.url;
                              },1000);
                          }).catch((error) => {
                          console.error("Error occur while pushing the tefdatalayer:", error);
                      });
                  }
              } else {
                  setFtthModelRedirectionState(true);
                  setFtthSelectedTariffState(selectedTariff);
                  setFtthmodalTariffPositionsState(getModalTariffPositions());
                  pushToTefDataLayer(window, buildDataForProductClickSelectTechnology(selectedTariff,
                      mainOffer.offerName === selectedTariff.offerName, ecommerceProductValues,
                      getModalTariffPositions()));
                  pushToTefDataLayer(window, buildDataForQuestionareModuleDisplay(selectedTariff, getModalTariffPositions()));
              }
            }
            }
        >
          Weiter
        </a>
  );
  return (
      <>
          <style> {css} </style>
          <div className="modal" id="modal-technologieauswahl" tabIndex={-1} role="dialog">
              <div className="modal-dialog modal-lg">
                  <div className="modal-content techSelection">
                      <div className="modal-header">
                          {closeButton()}
                      </div>
                      <div className="modal-body">
                          {tariffAlert()}
                          <div className="modal-footer">
                              {continueButton()}
                          </div>
                          {availableTechnologiesSelection()}
                          {serviceTeaser()}
                      </div>
                  </div>
              </div>
          </div>
          <StaticContentModal
              openerId="technologySelectInfoModal"
              displayCloseButton={false}
              titleContent={selectedTariffInfoModalContent[0]}
          >
              <p dangerouslySetInnerHTML={{__html: selectedTariffInfoModalContent[1]}}/>
          </StaticContentModal>
          <StaticContentModal
              openerId="glasfaserActivationCostInfoModal"
              displayCloseButton={true}
          >
              <p dangerouslySetInnerHTML={{__html: cmsContent[CmsPageContentIdentifier.ActivationCostInfoDescription]}}/>
          </StaticContentModal>
          <StaticContentModal
              openerId="glasfaserDevelopmentCostInfoModal"
              displayCloseButton={true}
          >
              <p dangerouslySetInnerHTML={{__html: cmsContent[CmsPageContentIdentifier.DevelopmentCostInfoDescription]}}/>
          </StaticContentModal>
      </>
  );
};

const mapStateToProps = (state: ReduxStateType) => ({
    cmsContent: state.cmsContent,
    ecommerceProductValues: state.result?.ecommerceProductValues || [],
    meta: state.meta,
});
const modelFooterStyle = `
         .item-collection { display: flex; justify-content: center; align-items: center; padding: 20px; }
         .footer-row { display: flex; gap: 20px; width: 100%; padding: 20px; border: 1px solid #ccc; border-radius: 8px; color: #000000;}
         .left-column, .right-column { flex: 1; margin-left: 10px;}
         .head-left { font-size: 30px; white-space: nowrap;}
         .teaser { margin-top: -10px;}
         .teaser .fcontent .footerhead { font-size: 16px; font-weight: bold;color: #000000; }
         .teaser .fcontent .ftext { margin-top: 5px; font-size: 14px; color: #000000;}
         @media (max-width: 768px) {
            .footer-row { flex-direction: column; border: none; padding: 15px; gap: 0px; }
            .left-column, .right-column { flex: none; width: 100%; margin-bottom: 15px; margin-left: 10px;}
            .head-left { font-size: 30px; white-space: nowrap; }
            .right-column { margin-top: -20px; margin-bottom: 0; }
            .teaser { margin-top: -10px;}
            .occlPromo { margin-bottom: 16px; }
         }
`;
const occlPromoBox = `
         @media (max-width: 768px) {
            .occlPromo { margin-bottom: 16px; }
         }
`;
export default connect(mapStateToProps)(TechnologySelectionModal);
